.modal__overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: var(--phx-modalBackgroundColor, #000);
  opacity: var(--phx-modalOpacity, 0.8);
}
.modal__wrapper {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}
.modal__container {
  z-index: 100;
  background: var(--phx-modalBackgroundContainer, #fff);
  position: relative;
  margin: auto;
  top: 50%;
  transform: translateY(-50%);
  width: fit-content;
  overflow-y: auto;
  max-height: var(--phx-modalMaxHeight, calc(100% - 64px));
  border-radius: var(--phx-modalBorderRadius, 8px);
}
.modal__content {
  padding: 40px;
}